import { CSSProperties, memo } from 'react'

import useImages from '../../states/useImages'
import useComponentLayout from '../../states/useComponentLayout'
import { CompareItemsTableImageCell as TCompareItemsTableImageCell } from '../../types'

import style from './ImageCell.module.scss'

export default memo(
  CompareItemsTableImageCell,
  (prevProps, nextProps) =>
    prevProps.width === nextProps.width &&
    prevProps.className === nextProps.className &&
    prevProps.cell === nextProps.cell
)
export function CompareItemsTableImageCell({
  className,
  width,
  cell
}: {
  className: string
  width: number
  cell: TCompareItemsTableImageCell
}) {
  const images = useImages()
  const componentLayout = useComponentLayout()

  const cellHeight = cell.imageWidth / images.imageRatio

  const hasImage = Boolean(cell.image?.path)

  const { dataVisualWidth = 0, attributeColFullWidth = 0 } = componentLayout.measures

  const imgStyle =
    0 <= dataVisualWidth && width > dataVisualWidth
      ? {
          position: 'sticky' as CSSProperties['position'],
          left: dataVisualWidth / 2 + attributeColFullWidth - cell.imageWidth / 2,
          margin: '0'
        }
      : null

  return (
    <div
      className={`${className || ''} ${style.CompareItemsTableImageCell}`}
      style={{ flex: `0 0 ${width}px`, width: `${width}px` }}
      data-compare-items="image-cell"
      data-compare-items-header-col={cell.col}
    >
      <div className={style.CompareItemsTableImageCell__img} style={imgStyle}>
        {hasImage && 'function' === typeof images.onClickImage.callback ? (
          <div
            className={style.CompareItemsTableImageCell__clickOverlay}
            onClick={() => {
              const itemIndex = cell.image._item._index
              if (null != itemIndex) {
                images.onClickImage.callback(itemIndex, cell.image._item, images.onClickImage.items)
              }
            }}
          >
            <i className={`icon-aytmfd-zoom ${style.CompareItemsTableImageCell__clickOverlay__zoomIcon}`} />
          </div>
        ) : null}
        {hasImage ? (
          <img
            src={images.getImageURL(cell.image.path, cell.imageWidth, cellHeight)}
            width={cell.imageWidth}
            height={cellHeight}
            alt={cell.image.alt}
          />
        ) : (
          <div
            className={style.CompareItemsTableImageCell__imagePlaceholder}
            style={{ ...(imgStyle || {}), width: cell.imageWidth, height: cellHeight }}
          >
            <svg viewBox="0 0 1000 1000">
              <path d="M615 181c0-19-15-34-34-34H437c-19 0-34 15-34 34V420h212C616 420 616 181 615 181zM599 286c-1 2-3 4-5 5l-55 17c-2 1-4 3-5 5l-17 55c-1 4-6 6-10 5-2-1-4-3-5-5l-17-55c-1-2-3-4-5-5l-55-17c-4-1-6-6-5-10 1-2 3-4 5-5L480 260c2-1 4-3 5-5l17-55c1-4 6-6 10-5 2 1 4 3 5 5l17 55c1 2 3 4 5 5l55 17C598 278 600 282 599 286zM347 208H234c-15 0-26 12-26 26v186h166V235C373 220 361 208 347 208zM348 323c0 2-2 3-3 3l-36 11c-2 0-3 2-3 3l-11 36c-1 3-4 4-6 3-2 0-3-2-3-3l-11-36c0-2-2-3-3-3l-36-11c-3-1-4-4-3-6 0-2 2-3 3-3l36-11c2 0 3-2 3-3l11-35c1-3 4-4 6-3 2 0 3 2 3 3l11 35c0 2 2 3 3 3l36 11C348 318 349 321 348 323zM783 208H670c-15 0-26 12-26 26v186h166V235C809 220 798 208 783 208zM785 323c-1 2-2 3-3 3l-36 11c-2 0-3 2-3 3l-11 36c-1 3-4 4-6 3-2 0-3-2-3-3l-11-36c-1-2-2-3-3-3l-36-11c-3-1-4-4-3-6 1-2 2-3 3-3l36-11c2 0 3-2 3-3l11-35c1-3 4-4 6-3 2 0 3 2 3 3l11 35c1 2 2 3 3 3l36 11C784 318 785 321 785 323zM403 442h212v421c0 19-15 34-34 34H437c-19 0-34-15-34-34V442zM208 442h166V770c0 15-12 26-26 26H234c-15 0-26-12-26-26C208 770 208 442 208 442zM644 442h166V770l0 0c0 15-12 26-26 26H670c-15 0-26-12-26-26V442zM938 344l-31 9c-1 0-2 2-3 3l-9 31c0 1-2 2-3 3-2 1-5-1-6-3l-9-31c0-1-2-2-3-3l-31-9c-1 0-2-2-3-3-1-2 1-5 3-5l31-9c1 0 2-2 3-3l9-31c0-1 2-2 3-3 2-1 5 1 6 3l9 31c0 1 2 2 3 3l31 9c1 0 2 2 3 3C942 341 941 343 938 344zM173 338c1 2-1 5-3 5l-31 9c-1 0-2 2-3 3l-9 31c0 1-1 2-3 3-2 1-5-1-6-3l-9-31c0-1-1-2-3-3l-31-9c-1 0-2-2-3-3-1-2 1-5 3-5l31-9c1 0 3-2 3-3l9-31c0-1 1-2 3-3 2-1 5 1 6 3l9 31c0 1 1 2 3 3l31 9C172 336 173 337 173 338zM170 335L170 335 170 335 170 335 170 335z"></path>
            </svg>
          </div>
        )}
      </div>
    </div>
  )
}
